// Delegation survives Horizon's variant-driven gallery replacement and editor reloads.
// Native click/tap zoom, drag navigation, videos and models keep their own handlers.
const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
let activeMedia;
let pendingFrame;

function resetZoom() {
  cancelAnimationFrame(pendingFrame);
  activeMedia?.classList.remove('is-hover-zoomed');
  activeMedia?.style.removeProperty('--zoom-x');
  activeMedia?.style.removeProperty('--zoom-y');
  activeMedia = undefined;
}

function getMedia(target) {
  if (!(target instanceof Element) || target.closest('dialog, zoom-dialog')) return;
  const container = target.closest('[data-product-hover-zoom="true"] .product-media-container--image');
  return container?.querySelector('.product-media');
}

document.addEventListener('pointermove', (event) => {
  if (!pointer.matches || event.pointerType !== 'mouse' || event.buttons) return resetZoom();
  const media = getMedia(event.target);
  if (media !== activeMedia) resetZoom();
  if (!media) return;
  activeMedia = media;
  cancelAnimationFrame(pendingFrame);
  pendingFrame = requestAnimationFrame(() => {
    if (!media.isConnected) return resetZoom();
    const bounds = media.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    const x = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
    const y = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
    media.style.setProperty('--zoom-x', `${x}%`);
    media.style.setProperty('--zoom-y', `${y}%`);
    media.classList.add('is-hover-zoomed');
  });
}, { passive: true });

document.addEventListener('pointerout', (event) => {
  if (activeMedia && getMedia(event.relatedTarget) !== activeMedia) resetZoom();
}, { passive: true });
document.addEventListener('pointerdown', resetZoom, { passive: true });
document.addEventListener('scroll', resetZoom, { passive: true, capture: true });
window.addEventListener('blur', resetZoom);
pointer.addEventListener('change', resetZoom);
